import { project } from '@/+state';
import {
  CheckupEnhanced,
  CheckupHeader,
} from '@/models/checkups/checkup.interface';
import { noDataIndicator } from '@/shared/content';
import { TableOptionsFrontend } from '@/shared/models/table-options';
import { dateFormatter } from '../../../../../shared/date-formatter';

const transformCheckups = (checkups, datetimeFormat: string) => {
  return checkups.map(checkup => {
    return {
      ...checkup,
      formattedDate: dateFormatter(
        checkup.checkupUpdatedAt,
        datetimeFormat,
        'dateTime',
      ),
    };
  });
};

export const checkupsAll = project<CheckupEnhanced[]>(({ stores }) => {
  return transformCheckups(
    stores.checkupsStore.data,
    stores.capabilitiesStore.capabilities.international.datetimeFormat,
  );
});

export const checkupsMostRecent = project<CheckupEnhanced[]>(({ stores }) => {
  return transformCheckups(
    stores.checkupsStore.initialData,
    stores.capabilitiesStore.capabilities.international.datetimeFormat,
  ).slice(0, 3);
});

export const checkupHeader = project<CheckupHeader>(({ stores }) => {
  const checkup = stores.checkupsStore.data.sort(
    (a, b) =>
      new Date(b.checkupUpdatedAt).getTime() -
      new Date(a.checkupUpdatedAt).getTime(),
  )[0];

  return {
    date: checkup
      ? dateFormatter(
          checkup.checkupUpdatedAt,
          stores.capabilitiesStore.capabilities.international.datetimeFormat,
          'date',
        )
      : noDataIndicator,
    surveyName: checkup?.surveyName || null,
    status: checkup?.status || null,
  };
});

export const checkupsLoading = project<boolean>(
  ({ stores }) => stores.checkupsStore.loading,
);

export const checkupsCount = project<number>(
  ({ stores }) => stores.checkupsStore.count,
);

export const checkupsRenderComponent = project<boolean>(
  ({ stores }) => stores.checkupsStore.renderComponent,
);

export const checkupsTableOptions = project<TableOptionsFrontend>(
  ({ stores }) => stores.checkupsStore.tableOptions,
);

export const checkupsProjections = [
  checkupsAll,
  checkupHeader,
  checkupsMostRecent,
  checkupsLoading,
  checkupsCount,
  checkupsRenderComponent,
  checkupsTableOptions,
];
